var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.90243 3H12.8399C13.7774 3 14.2499 3.4425 14.2499 4.3425V10.6575C14.2499 11.55 13.7774 12 12.8399 12H2.90243C1.96493 12 1.49243 11.55 1.49243 10.6575V4.3425C1.49243 3.4425 1.96493 3 2.90243 3ZM7.86743 9.45L12.9224 5.3025C13.1024 5.1525 13.2449 4.8075 13.0199 4.5C12.8024 4.1925 12.4049 4.185 12.1424 4.3725L7.86743 7.2675L3.59993 4.3725C3.33743 4.185 2.93993 4.1925 2.72243 4.5C2.49743 4.8075 2.63993 5.1525 2.81993 5.3025L7.86743 9.45Z",
    fill: "#5881FE",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.10977d9cfe3bdf729cf7d316c4f0d207.svg";
export { ForwardRef as ReactComponent };